export const validateMail = function (mailAdr) {
    var input = document.createElement('input');
    input.type='email';
    input.value=mailAdr;

    if (input.checkValidity()) {
        return true;
    }

    return false;
}

export const resetForm = function(elem) {
    console.log('reset');
    $(elem).closest("form").find("input").not(":hidden").each(function() {
        console.log(this);
        $(this).attr("value", "");
    })
}